// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogManagement-space1-Elkd7 {
	margin-bottom: 6px !important;
}

.BlogManagement-space2-YaGbg {
	margin-bottom: 12px !important;
}

.BlogManagement-space3-giD4V {
	margin-bottom: 18px !important;
}

.BlogManagement-space4-Dl7CZ {
	margin-bottom: 24px !important;
}

.BlogManagement-space5-Opu0m {
	margin-bottom: 30px !important;
}

.BlogManagement-space6-NbZIG {
	margin-bottom: 36px !important;
}

.BlogManagement-space7-orXL6 {
	margin-bottom: 42px !important;
}

.BlogManagement-space8-le7hM {
	margin-bottom: 48px !important;
}

.BlogManagement-spaceTop1-NnKFE {
	margin-top: 6px !important;
}

.BlogManagement-spaceTop2-tVjMX {
	margin-top: 12px !important;
}

.BlogManagement-spaceTop3-y2z6y {
	margin-top: 18px !important;
}

.BlogManagement-spaceTop4-OHBbX {
	margin-top: 24px !important;
}

.BlogManagement-spaceTop5-zKM7l {
	margin-top: 30px !important;
}

.BlogManagement-spaceTop6-hEjaY {
	margin-top: 36px !important;
}

.BlogManagement-spaceTop7-wpt2y {
	margin-top: 42px !important;
}

.BlogManagement-spaceTop8-V23Z5 {
	margin-top: 48px !important;
}

.BlogManagement-noMargin-PKzzq {
	margin: 0px !important;
}

.BlogManagement-padding1-L0HGS {
	padding-bottom: 6px !important;
}

.BlogManagement-padding2-nV89L {
	padding-bottom: 12px !important;
}

.BlogManagement-padding3-VVNDp {
	padding-bottom: 18px !important;
}

.BlogManagement-padding4-M8M3_ {
	padding-bottom: 24px !important;
}

.BlogManagement-padding5-Dn3Uj {
	padding-bottom: 30px !important;
}

.BlogManagement-padding6-gYdWY {
	padding-bottom: 36px !important;
}

.BlogManagement-padding7-aTxZ3 {
	padding-bottom: 42px !important;
}

.BlogManagement-paddingTop1-KsB2b {
	padding-top: 6px !important;
}

.BlogManagement-paddingTop2-ApuVC {
	padding-top: 12px !important;
}

.BlogManagement-paddingTop3-CAg8l {
	padding-top: 18px !important;
}

.BlogManagement-paddingTop4-NCESe {
	padding-top: 24px !important;
}

.BlogManagement-paddingTop5-GhyJU {
	padding-top: 30px !important;
}

.BlogManagement-paddingTop6-oQ_q2 {
	padding-top: 36px !important;
}

.BlogManagement-paddingTop7-ghAza {
	padding-top: 42px !important;
}

.BlogManagement-noPadding-kUx4d {
	padding: 0px !important;
}

.BlogManagement-spaceMarginBottom0-ll50q {
	margin-bottom: 0;
}

.BlogManagement-textBold-BfFO_ {
	font-weight: 500 !important;
}

.BlogManagement-textBolder-vbowR {
	font-weight: 700 !important;
}

.BlogManagement-textNormal-V6jhH {
	font-weight: normal !important;
}

/*New Design Text Colors */

.BlogManagement-textDarkBlue-_R1NL {
	color: rgb(20, 39, 94) !important;
}

.BlogManagement-textLightBlue-DIkoQ {
	color: rgb(57, 87, 106) !important;
}

.BlogManagement-textLightSandleGreen-Kzklr {
	color: rgb(76, 86, 41) !important;
}

.BlogManagement-textLightBrown-xTAee {
	color: rgb(115, 79, 33) !important;
}

.BlogManagement-textMediumMaroon-BTKOd {
	color: rgb(87, 37, 51) !important;
}

.BlogManagement-textBrown-Rfkz0 {
	color: rgb(160, 47, 24) !important;
}

.BlogManagement-textMaroon-pV601 {
	color: rgb(155, 49, 67) !important;
}

.BlogManagement-textDarkBrown-LrjsP {
	color: rgb(83, 18, 16) !important;
}

.BlogManagement-textMediumBrown-YT5ki {
	color: rgb(142, 28, 10) !important;
}

.BlogManagement-textSkyBlue-vhd8e {
	color: rgb(37, 117, 141) !important;
}

.BlogManagement-textGray-UrpP0 {
	color: rgb(77, 65, 51) !important;
}

.BlogManagement-errorMessage-qOlxh {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.BlogManagement-userText-Si56T {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.BlogManagement-panelHeader-g7qhx {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.BlogManagement-exportSection-lgEAS {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.BlogManagement-exportSectionGridSub-bXJ7G {
	grid-template-columns: 50% 49% !important;
}

.BlogManagement-exportText-e7WzP {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.BlogManagement-exportLinkImg-CTWoA {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.BlogManagement-exportImg-ChsSB {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.BlogManagement-linkBtn-AE3Co {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.BlogManagement-table-S4ka6 {
	display: table;
}

.BlogManagement-tableRow-zByaq {
	display: table-row;
}

.BlogManagement-tableCell-L1TW7 {
	display: table-cell;
	float: none;
}

.BlogManagement-formGroup-Eqk87 {
	margin-bottom: 6px;
}

.BlogManagement-marginTop0-G577m {
	margin-top: 0;
}

.BlogManagement-marginBottom20-z4o9G {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.BlogManagement-bannerImageBg-UmfJG {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.BlogManagement-bannerDelete-Bw3hY {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.BlogManagement-exportLink-D252l {
	padding-top: 10px;
	padding-right: 10px;
}

.BlogManagement-seachContent-yJFsy {
	padding-left: 0px;
	margin-bottom: 5px;
}

.BlogManagement-marginBottom9-bspeS {
	margin-bottom: 9px;
}

.BlogManagement-spaceTop52-B8ygn {
	margin-top: 52px;
}

.BlogManagement-profileViewInner-HS_Qv {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.BlogManagement-profileViewMain-PjaA6 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.BlogManagement-profileViewlabel-QKdfo {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.BlogManagement-profileViewMainContent-aMtP9 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.BlogManagement-reviewsFormStar-xe6Dx {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.BlogManagement-reviewsFormStar-xe6Dx svg {
	cursor: pointer;
}

.BlogManagement-addLanguageText-J8cGA {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.BlogManagement-exportSection-lgEAS {
		grid-template-columns: 100%;
	}

	.BlogManagement-spaceTop52-B8ygn {
		margin-top: 18px;
	}

	.BlogManagement-exportText-e7WzP {
		float: none;
		margin-top: 12px;
	}

	.BlogManagement-exportSectionGridSub-bXJ7G {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.BlogManagement-profileViewlabel-QKdfo {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.BlogManagement-profileViewMainContent-aMtP9 {
		width: 100%;
		text-align: center;
	}

	.BlogManagement-panelHeader-g7qhx {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `BlogManagement-space1-Elkd7`,
	"space2": `BlogManagement-space2-YaGbg`,
	"space3": `BlogManagement-space3-giD4V`,
	"space4": `BlogManagement-space4-Dl7CZ`,
	"space5": `BlogManagement-space5-Opu0m`,
	"space6": `BlogManagement-space6-NbZIG`,
	"space7": `BlogManagement-space7-orXL6`,
	"space8": `BlogManagement-space8-le7hM`,
	"spaceTop1": `BlogManagement-spaceTop1-NnKFE`,
	"spaceTop2": `BlogManagement-spaceTop2-tVjMX`,
	"spaceTop3": `BlogManagement-spaceTop3-y2z6y`,
	"spaceTop4": `BlogManagement-spaceTop4-OHBbX`,
	"spaceTop5": `BlogManagement-spaceTop5-zKM7l`,
	"spaceTop6": `BlogManagement-spaceTop6-hEjaY`,
	"spaceTop7": `BlogManagement-spaceTop7-wpt2y`,
	"spaceTop8": `BlogManagement-spaceTop8-V23Z5`,
	"noMargin": `BlogManagement-noMargin-PKzzq`,
	"padding1": `BlogManagement-padding1-L0HGS`,
	"padding2": `BlogManagement-padding2-nV89L`,
	"padding3": `BlogManagement-padding3-VVNDp`,
	"padding4": `BlogManagement-padding4-M8M3_`,
	"padding5": `BlogManagement-padding5-Dn3Uj`,
	"padding6": `BlogManagement-padding6-gYdWY`,
	"padding7": `BlogManagement-padding7-aTxZ3`,
	"paddingTop1": `BlogManagement-paddingTop1-KsB2b`,
	"paddingTop2": `BlogManagement-paddingTop2-ApuVC`,
	"paddingTop3": `BlogManagement-paddingTop3-CAg8l`,
	"paddingTop4": `BlogManagement-paddingTop4-NCESe`,
	"paddingTop5": `BlogManagement-paddingTop5-GhyJU`,
	"paddingTop6": `BlogManagement-paddingTop6-oQ_q2`,
	"paddingTop7": `BlogManagement-paddingTop7-ghAza`,
	"noPadding": `BlogManagement-noPadding-kUx4d`,
	"spaceMarginBottom0": `BlogManagement-spaceMarginBottom0-ll50q`,
	"textBold": `BlogManagement-textBold-BfFO_`,
	"textBolder": `BlogManagement-textBolder-vbowR`,
	"textNormal": `BlogManagement-textNormal-V6jhH`,
	"textDarkBlue": `BlogManagement-textDarkBlue-_R1NL`,
	"textLightBlue": `BlogManagement-textLightBlue-DIkoQ`,
	"textLightSandleGreen": `BlogManagement-textLightSandleGreen-Kzklr`,
	"textLightBrown": `BlogManagement-textLightBrown-xTAee`,
	"textMediumMaroon": `BlogManagement-textMediumMaroon-BTKOd`,
	"textBrown": `BlogManagement-textBrown-Rfkz0`,
	"textMaroon": `BlogManagement-textMaroon-pV601`,
	"textDarkBrown": `BlogManagement-textDarkBrown-LrjsP`,
	"textMediumBrown": `BlogManagement-textMediumBrown-YT5ki`,
	"textSkyBlue": `BlogManagement-textSkyBlue-vhd8e`,
	"textGray": `BlogManagement-textGray-UrpP0`,
	"errorMessage": `BlogManagement-errorMessage-qOlxh`,
	"userText": `BlogManagement-userText-Si56T`,
	"panelHeader": `BlogManagement-panelHeader-g7qhx`,
	"exportSection": `BlogManagement-exportSection-lgEAS`,
	"exportSectionGridSub": `BlogManagement-exportSectionGridSub-bXJ7G`,
	"exportText": `BlogManagement-exportText-e7WzP`,
	"exportLinkImg": `BlogManagement-exportLinkImg-CTWoA`,
	"exportImg": `BlogManagement-exportImg-ChsSB`,
	"linkBtn": `BlogManagement-linkBtn-AE3Co`,
	"table": `BlogManagement-table-S4ka6`,
	"tableRow": `BlogManagement-tableRow-zByaq`,
	"tableCell": `BlogManagement-tableCell-L1TW7`,
	"formGroup": `BlogManagement-formGroup-Eqk87`,
	"marginTop0": `BlogManagement-marginTop0-G577m`,
	"marginBottom20": `BlogManagement-marginBottom20-z4o9G`,
	"bannerImageBg": `BlogManagement-bannerImageBg-UmfJG`,
	"bannerDelete": `BlogManagement-bannerDelete-Bw3hY`,
	"exportLink": `BlogManagement-exportLink-D252l`,
	"seachContent": `BlogManagement-seachContent-yJFsy`,
	"marginBottom9": `BlogManagement-marginBottom9-bspeS`,
	"spaceTop52": `BlogManagement-spaceTop52-B8ygn`,
	"profileViewInner": `BlogManagement-profileViewInner-HS_Qv`,
	"profileViewMain": `BlogManagement-profileViewMain-PjaA6`,
	"profileViewlabel": `BlogManagement-profileViewlabel-QKdfo`,
	"profileViewMainContent": `BlogManagement-profileViewMainContent-aMtP9`,
	"reviewsFormStar": `BlogManagement-reviewsFormStar-xe6Dx`,
	"addLanguageText": `BlogManagement-addLanguageText-J8cGA`
};
module.exports = ___CSS_LOADER_EXPORT___;
